<template>
  <div class="row">
    <div class="col-md-12">
      <h3>Points Earned</h3> 
    </div>
    
    <div class="col-lg-4 col-sm-12">
      <div class="card">
        <div class="card-header text-center">
          <h5 class="card-title">Today</h5>
          <p class="card-category"></p>
        </div>
        <div class="card-body text-center">
          <h3>{{ earnedToday }}</h3>
        </div>
      </div>
    </div>

    <div class="col-lg-4 col-sm-12">
      <div class="card">
        <div class="card-header text-center">
          <h5 class="card-title">This Week</h5>
        </div>
        <div class="card-body text-center">
          <h3>{{ earnedThisWeek }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-sm-12">
      <div class="card">
        <div class="card-header text-center">
          <h5 class="card-title">This Month</h5>
        </div>
        <div class="card-body text-center">
          <h3>{{ earnedThisMonth }}</h3>
        </div>
      </div>
    </div>
    


    <div class="col-md-12">
      <h3>Points Redeemed</h3> 
    </div>

    <div class="col-lg-4 col-sm-12">
      <div class="card">
        <div class="card-header text-center">
          <h5 class="card-title">Today</h5>
          <p class="card-category"></p>
        </div>
        <div class="card-body text-center">
          <h3>{{ redeemedToday }}</h3>
        </div>
      </div>
    </div>

    <div class="col-lg-4 col-sm-12">
      <div class="card">
        <div class="card-header text-center">
          <h5 class="card-title">This Week</h5>
        </div>
        <div class="card-body text-center">
          <h3>{{ redeemedThisWeek }}</h3>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-sm-12">
      <div class="card">
        <div class="card-header text-center">
          <h5 class="card-title">This Month</h5>
        </div>
        <div class="card-body text-center">
          <h3>{{ redeemedThisMonth }}</h3>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          
          <div class="col-sm-12">
            <div class="card" v-for="(data, index) in queriedData" :key="index">
              <div class="card-body">
                <div style="border-bottom: 1px #ebeef5 solid;">
                  <strong>{{data.business_name}}</strong>
                  <a :href="data.merchantUrl" style="float: right;"><span class="ti-angle-right"></span></a>
                </div>
                <div class="row" style="text-align:right;">
                  <div class="col-md-3" style="padding-top:12px;">{{data.earned}}</div>
                  <div class="col-md-3" style="padding-top:12px;">{{data.redeemed}}</div>
                  <div class="col-md-3" style="padding-top:12px;">{{data.balance }}</div>
                  <div class="col-md-3">
                    <button 
                      type="button" :disabled="data.balance < 200000"
                      class="btn btn-round btn-success btn-sm btn-block">
                      Redeem
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import BarChart from 'src/components/UIComponents/Charts/HorizontalBarChart'
 

  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      Card,
      PPagination
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data() {
      return {
        loaded: false,
        earnedToday: 0,
        earnedThisWeek: 0,
        earnedThisMonth: 0,
        redeemedToday: 0,
        redeemedThisWeek: 0,
        redeemedThisMonth: 0,


        model: {
          labels: []
        },
        
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['business_name'],
        
        tableData: []
      }
    },
    methods: {

      getRewards () {
        this.$http.get('/rewards')
        .then(response => {
          this.tableData = response.data
          

          response.data.map(function (e) {
            let balance = e.earned - e.redeemed
            e.merchantUrl = "#/rewards/" + e.business_name.toLowerCase() + "/transactions"
            e.balance = balance
          });

        })
        .catch(error => {
          
        })
      },

      getEarnedToday () {
        this.$http.get('/rewards/today')
        .then(response => {
          this.earnedToday = response.data
        })
        .catch(error => {
          
        })
      },

      getEarnedThisWeek () {
        this.$http.get('/rewards/week')
        .then(response => {
          this.earnedThisWeek = response.data
        })
        .catch(error => {
          
        })
      },

      getEarnedThisMonth () {
        this.$http.get('/rewards/month')
        .then(response => {
          this.earnedThisMonth = response.data
        })
        .catch(error => {
          
        })
      },
      
    },

    async mounted () {
      this.getEarnedToday ()
      this.getEarnedThisWeek ()
      this.getEarnedThisMonth ()
      this.getRewards ()
    }
  }
</script>
<style lang="scss">
  
</style>
